import React from "react";

import { Box, Button, Divider } from "@mui/material";
import { useFormContext } from "react-hook-form";

import If from "@/components/layout/If";
import Visibility from "@/components/layout/Visibility";

import { RecipeFormValues } from "./RecipeForm";

interface Props {
  submitLabel: string;
  onCancel: () => void;
}

const RecipeFormFooter: React.FC<Props> = ({ submitLabel, onCancel }) => {
  const {
    watch,
    setValue,
    formState: { isValid, isSubmitting },
  } = useFormContext<RecipeFormValues>();

  const [activeStep, completedSteps] = watch([
    "meta.activeStep",
    "meta.completedSteps",
  ]);

  const hasPreviousStep = activeStep !== 0;
  const hasNextStep = activeStep !== 1;

  const handlePrevStep = () => {
    setValue("meta.activeStep", activeStep - 1);
  };

  const handleNextStep = () => {
    setValue("meta.activeStep", activeStep + 1);

    const newCompletedSteps = { ...completedSteps, [activeStep]: true };
    setValue("meta.completedSteps", newCompletedSteps);
  };

  return (
    <Box mt={1}>
      <Divider />
      <Box py={4} px={6} display="flex" width="100%">
        <Box flex={1}>
          <Visibility visible={hasPreviousStep}>
            <Button variant="outlined" onClick={handlePrevStep}>
              Back
            </Button>
          </Visibility>
        </Box>
        <Box flex={1} display="flex" justifyContent="center">
          <Button variant="outlined" onClick={onCancel}>
            Cancel
          </Button>
          <Box ml={3}>
            <If
              condition={hasNextStep}
              then={
                <Button key="next" disabled={!isValid} onClick={handleNextStep}>
                  Next
                </Button>
              }
              else={
                <Button
                  // Provide a `key` prop so that form won't submit immediately
                  // after clicking Next button.
                  key="submit"
                  type="submit"
                  disabled={!isValid || isSubmitting}
                >
                  {submitLabel}
                </Button>
              }
            />
          </Box>
        </Box>
        {/* For spacing only */}
        <Box flex={1} />
      </Box>
    </Box>
  );
};

export default RecipeFormFooter;
